import type { EventEmitter } from '@stencil/core';

const iconEventEmitter = (
  gaIconEventEmitter: EventEmitter<{ actionItem: string; keyword: string }>,
  actionItem: string,
  query: string,
) => {
    gaIconEventEmitter.emit({
      actionItem,
      keyword: query,
    });
};

export const collapseChat = (
  gaIconEventEmitter: EventEmitter<{ actionItem: string; keyword: string }>,
  chatVisibilityEventEmitter: EventEmitter<{ isChatVisible: boolean }>,
  query: string,
) => {
    const closeChatIconName = 'Cross';

    iconEventEmitter(gaIconEventEmitter, closeChatIconName, query);
    chatVisibilityEventEmitter.emit({ isChatVisible: false });
};

export const onNewConversationClickAction = (
  userStartingNewConversationEventEmitter: EventEmitter,
  gaIconEventEmitter: EventEmitter<{ actionItem: string; keyword: string }>,
  query: string,
) => {
    const newConversationiconName = 'Plus circle';
    userStartingNewConversationEventEmitter.emit();
    iconEventEmitter(
      gaIconEventEmitter,
      newConversationiconName,
      query,
    );
};
